import React from 'react';

const Introduction = ({ sectionData, baseUrl }) => {
  if (!sectionData) return null;

  return (
    <>
      {sectionData.map((item, index) => (
        <section key={item.id} className={index % 2 !== 0 ? 'bg-light py-5' : 'py-5'}>
          <div className="container">
            
            {/* Heading */}
            {item.heading && (
              <div className="sec-title text-center mb-4">
                <h2>{item.heading}</h2>
              </div>
            )}

            <div className={`row d-flex justify-content-center align-items-center ${item.image_position === 'right' ? 'flex-column-reverse flex-md-row' : ''}`}>
              
              {/* Left Image */}
              {item.image_position === 'left' && item.image && (
                <div className="col-md-4 col-12 mb-3 mb-md-0">
                  <img
                    src={`${baseUrl}/public${item.image}`}
                    alt={item.heading}
                    className="img-fluid rounded shadow-sm"
                  />
                </div>
              )}

              {/* Text Content */}
              <div className={item.image ? "col-md-8 col-12" : "col-12"}>
                
                {/* Paragraphs */}
                {item.textareas && item.textareas.map((text, i) => (
                  <p key={i} style={{ textAlign: "justify" }}>{text}</p>
                ))}

                {/* List Points */}
                {item.list_points && item.list_points.length > 0 && (
                  <ul className="member-list list-unstyled mt-3">
                    {item.list_points.map((point, i) => (
                      <li key={i} className="mb-2">
                        <i className="fa fa-dot-circle-o text-primary me-2"></i> {point}
                      </li>
                    ))}
                  </ul>
                )}

                {/* Optional PDF Download Button (New Feature) */}
                {item.pdf_file && (
                  <div className="mt-3">
                    <a 
                      href={`${baseUrl}${item.pdf_file}`} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="btn btn-outline-primary btn-sm"
                    >
                      <i className="fa fa-file-pdf-o me-2"></i>
                      {item.pdf_name || "Download Attachment"}
                    </a>
                  </div>
                )}
              </div>

              {/* Right Image */}
              {item.image_position === 'right' && item.image && (
                <div className="col-md-4 col-12 mb-3 mb-md-0">
                  <img
                    src={`${baseUrl}/public${item.image}`}
                    alt={item.heading}
                    className="img-fluid rounded shadow-sm"
                  />
                </div>
              )}

            </div>
          </div>
        </section>
      ))}
    </>
  );
};

export default Introduction;